import React from "react";
import './loader.scss';
import EnergicLogo from "../EnergicLogo";

const Loader = () => (
    <div
        className='loader'
    >
        <div className='nakoumContainer'>
            <EnergicLogo />
        </div>
        <div className="dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
        </div>
    </div>
);

export default Loader;